import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, Input, Output, OnDestroy } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-zip-import',
  templateUrl: './zip-import.component.html',
  styleUrls: ['./zip-import.component.scss']
})
export class ZipImportComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() id: any;

  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();


  @Input() productId;
  text: string;
  constructor(private productService: ProductService,
    private snackBar: MatSnackBar, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
    this.s()
    this.text = "Upload"
    console.log("s", this.productId)
  }


  @ViewChild("myInput")
  myInputVariable: ElementRef;


  item: FileLikeObject;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ["compress"],
  });

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  upload() {
    let files = this.getFiles();
    let dataExport = new FormData();
    files.forEach((file) => {
      dataExport.append('file', file.rawFile, file.name);
    });
    this.text = "Processing"
    this.productService.uploadImageZip(dataExport, this.id, this.productId).subscribe(
      res => {
        this.text = "Upload"
        if (res['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.uploader.clearQueue();


          this.onSuccess.emit(res);;

        }
        else {
          this.snackBar.open(res['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.onSuccess.emit(res);;
        }
      },
      error => {
        console.log(error);
        this.text = "Upload"
      }
    );
  }


  s() {
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      this.item = item;
      switch (filter.name) {
        case 'fileType':
          this.snackBar.open("uploaded wrong file type, " + item.name, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        case 'fileSize':
          this.snackBar.open("  The file could not be uploaded because it exceeds 5mb,the maximum allowed size for uploads ", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        default:
          break;
      }
    };

  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
